function height(el) {
	var height = 0;
	$(el).each(function () {
		var thisHeight = $(this).height();
		if (thisHeight > height) {
			height = thisHeight;
		}
		setTimeout(() => {
			$(el).height(height)
		}, 100)
	})
}
let header = {
	scrollActive: function () {
		let height = $('header').height()
		if ($(window).scrollTop() > height) {
			$('header').addClass('active')
		} else {
			$('header').removeClass('active')
		}
	},
}

function setBackgroundElement() {
	$('[setBackground]').each(function () {
		var background = $(this).attr('setBackground')
		$(this).css({
			"background-image": "url(" + background + ")",
			"background-size": "cover",
			"background-position": "center center"
		})
	})
	$('[setBackgroundRepeat]').each(function () {
		var background = $(this).attr('setBackgroundRepeat')
		$(this).css({
			"background-image": "url(" + background + ")",
			"background-repeat": "repeat"
		})
	})
}

function mappingMenu() {
	let mainMenu = $('header .bottom-wrap .main-menu').mapping({
		mobileWrapper: 'header .mobile-wrap',
		mobileMethod: 'appendTo',
		desktopWrapper: 'header .bottom-wrap .left-wrap',
		desktopMethod: 'appendTo',
		breakpoint: 1024
	});
	let searchbox = $('header .bottom-wrap .searchbox').mapping({
		mobileWrapper: 'header .mobile-wrap',
		mobileMethod: 'appendTo',
		desktopWrapper: 'header .bottom-wrap .right-wrap .main-search',
		desktopMethod: 'appendTo',
		breakpoint: 1024
	});
	let language = $('header .top-wrap .main-language').mapping({
		mobileWrapper: 'header .mobile-wrap',
		mobileMethod: 'appendTo',
		desktopWrapper: 'header .top-wrap .right-wrap',
		desktopMethod: 'appendTo',
		breakpoint: 1024
	});
}

function menuMobile() {
	let buttonToggle = $('header .button-menu-mb')
	buttonToggle.on('click', function () {
		$('header .mobile-wrap').toggleClass('active')
	})

	// toggle title
	let toggleLink = $('header .main-menu>li .title-zone-1')
	let toggleLink2 = $('header .main-menu>li .title-zone-2')
	toggleLink.on('click', function () {
		$(this).next('.dropdown-list').slideToggle();
	})
	toggleLink2.on('click', function () {
		$(this).next('.dropdown-list-2').slideToggle();
	})
}

function initSlide() {
	let bannerHome = new Swiper('.sakura-home-1 .swiper-container', {
		spaceBetween: 30,
		loop: true,
		autoplay: {
			delay: 4500,
		},
		slidesPerColumnFill: "row",
		pagination: {
			el: '.sakura-home-1 .swiper-pagination',
			clickable: true,
		},
	});
	let catalogHome = new Swiper('.sakura-home-2 .swiper-container', {
		spaceBetween: 30,
		slidesPerView: 1,
		slidesPerColumnFill: "row",
		navigation: {
			nextEl: '.sakura-home-2 .button-next',
			prevEl: '.sakura-home-2 .button-prev',
		},
		breakpoints: {
			576: {
				slidesPerView: 2,
			},
			768: {
				slidesPerView: 3
			},
			1024: {
				slidesPerView: 4
			}
		}

	});
	let historyTop = new Swiper('.sakura-about-2 .main-slide-top .swiper-container', {
		spaceBetween: 30,
		slidesPerView: 2,
		slidesPerColumnFill: "row",

		breakpoints: {
			576: {
				slidesPerView: 3,
			},
			768: {
				slidesPerView: 4
			}
		}

	});
	let historyBottom = new Swiper('.sakura-about-2 .main-slide-bottom .swiper-container', {
		spaceBetween: 30,
		slidesPerColumnFill: "row",
		thumbs: {
			swiper: historyTop
		},
		navigation: {
			nextEl: '.sakura-about-2 .button-next',
			prevEl: '.sakura-about-2 .button-prev',
		},
	});
	// let productDetailTop = new Swiper('.sakura-categories-detail .main-slide-bottom .swiper-container', {
	// 	spaceBetween: 30,
	// 	slidesPerView: 2,
	// 	slidesPerColumnFill: "row",

	// 	breakpoints: {
	// 		576: {
	// 		slidesPerView: 3,
	// 		},
	// 		768: {
	// 		slidesPerView: 4
	// 		}
	// 	}
	// });
	// let productDetailBottom = new Swiper('.sakura-categories-detail .main-slide-top .swiper-container', {
	// 	spaceBetween: 30,
	// 	slidesPerColumnFill: "row",
	// 	thumbs: {
	// 		swiper: productDetailTop
	// 	},
	// 	navigation: {
	// 		nextEl: '.sakura-categories-detail .button-next',
	// 		prevEl: '.sakura-categories-detail .button-prev',
	// 	},
	// });
}

function leteringColor() {
	$(".name-logo h2").lettering();
	$('.name-logo h2 span').each(function (index) {
		let $this = $(this)
		$this.attr('style', '--i:' + index)
	})
}

function showAllContent() {
	let viewMore = $('.sakura-categories-detail .box-product-bottom .view-more')
	let viewMoreBrief = $('.sakura-categories-detail .box-product-top .box-content .brief-content .view-more')
	let viewMoreTable = $('.sakura-categories-detail .box-table .view-more')
	viewMore.on('click', function () {
		$(this).slideUp();
		$('.sakura-categories-detail .box-product-bottom .tabslet-content.active .full-content').toggleClass('show-full')
	})
	viewMoreTable.on('click', function () {
		// console.log(100)
		$(this).slideUp();
		$('.sakura-categories-detail .box-table .table').toggleClass('active')
	})
	viewMoreBrief.on('click', function () {
		// console.log(100)
		$(this).slideUp();
		$('.sakura-categories-detail .box-product-top .box-content .brief-content .briefcontent').toggleClass('active')
	})
}

function shareSocial() {
	$("#shareNewsDeail").jsSocials({
		showLabel: false,
		showCount: false,
		shareIn: "popup",
		shares: [{
				share: "facebook",
				logo: "fab fa-facebook-f"
			},
			{
				share: "twitter",
				logo: "fab fa-twitter"
			},
		],

	});
	$("#share-product").jsSocials({
		showLabel: false,
		showCount: false,
		shareIn: "popup",
		shares: [{
			share: "facebook",
			logo: "ri-facebook-fill"
		}],

	});
}

function changeIframe() {
	$(document).on('click', '.sakura-maps ul li', function () {
		var data = $(this).attr('data-iframe')
		$('#custom-maps iframe').attr('src', data)
	})
}

function copyHtml() {
	let capchaHtml = $('.wrap-form .frm-captcha')
	let boxVideo = $('.product-detail-page .box-video')
	let refreshImg = $('.rcRefreshImage')
	boxVideo.appendTo('.product-detail-page .main-video-js')
	// setInterval(() => {
	capchaHtml.appendTo('.main-capcha')
	// }, 100);
	refreshImg.on('click', function () {
		let capchaHtml2 = $('.wrap-form .frm-captcha')
		console.log(capchaHtml2);
		setTimeout(() => {
			capchaHtml2.clone().appendTo('.main-capcha')
		}, 1000);
	})

}

$(document).on('scroll', function () {
	header.scrollActive()
})

$(document).ready(function () {
	setBackgroundElement();
	// header 
	leteringColor();
	mappingMenu();
	menuMobile();

	// swiper
	initSlide();
	showAllContent();

	shareSocial();
	copyHtml();

	changeIframe();
	setTimeout(() => {
		$('#l_0').trigger("click")
	}, 500);
})
